import Utils from '@/utils/functionTools';
import OSS from 'ali-oss';
import html2canvas from 'html2canvas';
import loading from '../plugin/loading/loadingObj';
import {Toast} from 'vant';
class ShareImg {
  static htmlsCanvas (doc) {
    loading.show();
    return new Promise((resolve, reject) => {
      (window.html2canvas || html2canvas)(doc, {
        allowTaint: false,
        useCORS: true,
        backgroundColor: '#fff',
        logging: false,
        scale: 1,
        dpi: 100,
        scrollY: 0,
        scrollX: 0
      }).then(
        (canvas) => {
          this.compress(canvas, blod => {
            if (Utils.judgeVersion('7.0.0')) {
              loading.hide();
              resolve(blod)
            } else {
              const client = new OSS({
                region: 'oss-cn-qingdao',
                accessKeyId: 'LTAICrDd0avLrBqu',
                accessKeySecret: 'fry0NyshnJqfFbI0JAcuk1ew7NZKe0',
                bucket: 'app-ccchong-com'
              });
              client.put(this.createFileName() + '.png', blod)
                .then(res => {
                  loading.hide();
                  resolve(res.url)
                })
                .catch(e => {
                  reject(e)
                  loading.hide();
                  Toast.show('图片上传失败');
                });
            }
          });
        })
        .catch(err => {
          reject(err)
          loading.hide();
          console.log('err: ', err);
        })
    })
  }

  static createFileName () {
    function S4 () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (
      `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
    );
  }

  static dataURLToBlob (dataurl) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n > 0) {
      n--
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
  }

  static compress (canvas, cb) {
    const image = new Image(); //新建一个img标签（还没嵌入DOM节点)
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = canvas.toDataURL('image/png');
    image.onload = function () {
      const canvas2 = document.createElement('canvas')
      const context = canvas2.getContext('2d')
      const imageWidth = image.width;    // 压缩后图片的大小
      const imageHeight = image.height;
      canvas2.width = imageWidth;
      canvas2.height = imageHeight;
      context.drawImage(image, 0, 0, imageWidth, imageHeight);
      if (Utils.judgeVersion('7.0.0')) {
        cb(canvas2.toDataURL('image/png'));
      } else {
        cb(ShareImg.dataURLToBlob(canvas2.toDataURL('image/png')));
      }
    }
  }
}

export default ShareImg



// WEBPACK FOOTER //
// ./src/starcharge/utils/shareImg.js